module.exports = __webpack_public_path__ + "static/media/br.807399d3.jpg";